import { DividerProps, Divider as MuiDivider } from '@mui/material';

interface CustomDividerProps extends DividerProps {
  dashed?: boolean;
}

const Divider = ({ dashed, sx, ...props }: CustomDividerProps) => {
  return (
    <MuiDivider
      sx={{
        ...(dashed && { borderStyle: 'dashed' }),
        ...sx,
      }}
      {...props}
    />
  );
};

export default Divider;
